// extracted by mini-css-extract-plugin
module.exports = {"container":"_2f5T7"};